import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const mlaCityViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map